import {
    // StatsGl,
    Stats,
    AdaptiveEvents,
    Environment,
    // OrbitControls,
    Preload,
    useEnvironment
} from '@react-three/drei';
import LighterModel from '../../models/LighterModel/LighterModel';
import Cam from '../../models/Cam/Cam';
// import { useControls } from 'leva';
import { memo, useRef, useCallback} from 'react';
import {
    EffectComposer,
    BrightnessContrast,
    SMAA
} from '@react-three/postprocessing';
import { useFrame } from '@react-three/fiber';
import { useMainContext } from 'hooks/useMainContext';
import { Perf } from 'r3f-perf';
import { useFontLoader } from '../../../hooks/useFontLoader';

const CanvasSetting = () => {
    const { center } = useMainContext();
    const envMap = useEnvironment({ files: '/leading/leadingPageAssets/skyBox/midday.hdr' });
    
    const brightnessRef = useRef<any>();
    const hasTriggeredFontLoad = useRef<boolean>(false);
    
    // 使用字體載入 hook，但不自動載入
    const { isLoading: fontLoading, isLoaded: fontLoaded, loadFonts } = useFontLoader({ loadOnMount: false });

    const handleFontLoad = useCallback(async () => {
        if (!hasTriggeredFontLoad.current) {
            hasTriggeredFontLoad.current = true;
            // console.log('brightness 為 0，開始載入字體...');
            await loadFonts();
        }
    }, [loadFonts]);

    useFrame(() => {
        if (!brightnessRef.current) return;
        
        brightnessRef.current.brightness = center.brightness;
        // console.log('brightness', center.brightness);
        
        // 當 brightness 為 0 且尚未載入字體時，觸發字體載入
        if (center.brightness === 0 && !hasTriggeredFontLoad.current) {
            handleFontLoad();
        }
    });

    return (
        <> 
            {
                process.env.NODE_ENV === 'development' && 
                (<>
                    <Perf 
                        position="bottom-left" 
                        debug={true}
                    />
                    <Stats showPanel={0} />
                </>)
            }
            
            <Preload all />
            <Environment map={envMap} />
            <Cam />
            <LighterModel />
            <AdaptiveEvents />

            <EffectComposer>
                <BrightnessContrast
                    ref={brightnessRef}
                    brightness={0}
                />
                <SMAA />
            </EffectComposer>
        </>
    );
};

export default memo(CanvasSetting);
